export default {
    name: 'DateTimeRangeInput',
    filter(field, filterForm, options) {

        let fieldStartDate = field + 'StartDate'
        let fieldEndDate = field + 'EndDate'

        return {
            component: "oc-form-field",
            options() {

                let startDate = filterForm[fieldStartDate]
                let endDate = filterForm[fieldEndDate]

                if( filterForm[field] && ( ! startDate || ! endDate ) )
                {
                    let parts = filterForm[field].split(options.separator)

                    startDate = parts[0]
                    endDate = parts[1]
                }

                return {
                    input: 'oc-datetime-range-input',
                    inputAttrs: {
                        startDate,
                        endDate
                    }
                }
            },
            events: {
                'update:startDate': (event) => {
                    filterForm.set(fieldStartDate, event)
                },
                'update:endDate': (event) => {
                    filterForm.set(fieldEndDate, event)
                }
            }
        }
    }
}
